// 50+ US cities, one SEO landing page each.
//
// These entries carry only descriptive copy - name, location, and prose. They
// deliberately contain NO player or venue counts. Every city used to ship
// invented figures here (playerCount 240-5,400, venueCounts such as "30 tennis
// venues"), and CityPage rendered them as fact: the Dallas page claimed 1,200
// active players in a city where the product had no player and no venue. Those
// pages are indexable, so the claims were findable as well as visible.
//
// Counts now come from GET /api/cities, which reports only cities with a real
// mapped venue. If a city has no venues, the page says we are not there yet
// instead of inventing a number. Adding a count back to this file would
// reintroduce exactly the problem it was removed to fix.
export const CITIES = [
  {
    name: "Fort Worth", state: "Texas", stateCode: "TX",
    slug: "fort-worth", stateSlug: "texas",
    lat: 32.7555, lng: -97.3307,
    description: "ActivitySports' launch city. 12 verified venues, with an active tennis and pickleball community.",
    topSports: ["tennis", "pickleball", "golf", "climbing"],
    highlights: ["Bayard H. Friedman Tennis Center (TCU)", "McLeland Tennis Center", "Rockwood Park Golf Course"],
  },
  {
    name: "Dallas", state: "Texas", stateCode: "TX",
    slug: "dallas", stateSlug: "texas",
    lat: 32.7767, lng: -96.7970,
    description: "Massive sports scene with world-class facilities across Uptown, Lakewood, and the Metroplex.",
    topSports: ["tennis", "pickleball", "golf", "padel"],
    highlights: ["Reverchon Park", "Topgolf Las Colinas", "Fretz Park Pickleball"],
  },
  {
    name: "Austin", state: "Texas", stateCode: "TX",
    slug: "austin", stateSlug: "texas",
    lat: 30.2672, lng: -97.7431,
    description: "Tech-forward city with a booming outdoor sports culture — pickleball and climbing especially popular.",
    topSports: ["tennis", "pickleball", "climbing", "golf"],
    highlights: ["Pharr Tennis Center", "Lifetime Fitness Pickleball", "Austin Bouldering Project"],
  },
  {
    name: "Denver", state: "Colorado", stateCode: "CO",
    slug: "denver", stateSlug: "colorado",
    lat: 39.7392, lng: -104.9903,
    description: "Mile High City with incredible skiing, climbing, and growing pickleball scene.",
    topSports: ["ski", "climbing", "tennis", "pickleball"],
    highlights: ["Keystone Resort", "Movement Denver Climbing", "Cheesman Park Tennis"],
  },
  {
    name: "New York", state: "New York", stateCode: "NY",
    slug: "new-york", stateSlug: "new-york",
    lat: 40.7128, lng: -74.0060,
    description: "The city that never sleeps has 30 clay courts in Central Park, world-class squash clubs, and a surging pickleball scene.",
    topSports: ["tennis", "squash", "pickleball", "table-tennis"],
    highlights: ["Central Park Tennis Center", "Vanderbilt Athletic Club", "HK Pickleball"],
  },
  {
    name: "Los Angeles", state: "California", stateCode: "CA",
    slug: "los-angeles", stateSlug: "california",
    lat: 34.0522, lng: -118.2437,
    description: "Year-round sunshine means endless tennis, pickleball, golf, and beach sports.",
    topSports: ["tennis", "pickleball", "golf", "padel"],
    highlights: ["Griffith Park Courts", "Balboa Tennis Center", "Rose Bowl Aquatics"],
  },
  {
    name: "Chicago", state: "Illinois", stateCode: "IL",
    slug: "chicago", stateSlug: "illinois",
    lat: 41.8781, lng: -87.6298,
    description: "Lakefront parks packed with tennis courts, active badminton clubs, and year-round indoor options.",
    topSports: ["tennis", "badminton", "squash", "pickleball"],
    highlights: ["Waveland Tennis Courts", "Midtown Athletic Club", "Chicago Badminton Club"],
  },
  {
    name: "Houston", state: "Texas", stateCode: "TX",
    slug: "houston", stateSlug: "texas",
    lat: 29.7604, lng: -95.3698,
    description: "Enormous city with a thriving tennis and golf scene, plus growing pickleball courts.",
    topSports: ["tennis", "golf", "pickleball", "badminton"],
    highlights: ["Memorial Park Tennis", "Westwood Country Club", "Almeda Pickleball Courts"],
  },
  {
    name: "Phoenix", state: "Arizona", stateCode: "AZ",
    slug: "phoenix", stateSlug: "arizona",
    lat: 33.4484, lng: -112.0740,
    description: "Sun-drenched desert city with one of the fastest-growing pickleball communities in the US.",
    topSports: ["pickleball", "tennis", "golf", "padel"],
    highlights: ["Desert Ridge Pickleball", "Encanto Tennis", "Camelback Golf Club"],
  },
  {
    name: "Philadelphia", state: "Pennsylvania", stateCode: "PA",
    slug: "philadelphia", stateSlug: "pennsylvania",
    lat: 39.9526, lng: -75.1652,
    description: "Historic city with active squash leagues, Fairmount Park tennis, and table tennis clubs.",
    topSports: ["tennis", "squash", "table-tennis", "pickleball"],
    highlights: ["Fairmount Park Courts", "Philly Table Tennis", "Penn Athletic Club"],
  },
  {
    name: "San Antonio", state: "Texas", stateCode: "TX",
    slug: "san-antonio", stateSlug: "texas",
    lat: 29.4241, lng: -98.4936,
    description: "Warm climate with public parks across the city supporting tennis, golf, and pickleball.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["McAllister Park", "Pecan Valley Golf Course", "Mission Trail Pickleball"],
  },
  {
    name: "San Diego", state: "California", stateCode: "CA",
    slug: "san-diego", stateSlug: "california",
    lat: 32.7157, lng: -117.1611,
    description: "Balboa Park's massive public tennis complex and perfect beach weather make San Diego a sports paradise.",
    topSports: ["tennis", "pickleball", "golf", "climbing"],
    highlights: ["Morley Field Tennis", "Mission Bay Aquatics", "The Pines Golf Course"],
  },
  {
    name: "San Jose", state: "California", stateCode: "CA",
    slug: "san-jose", stateSlug: "california",
    lat: 37.3382, lng: -121.8863,
    description: "Silicon Valley's sports hub with excellent private tennis clubs and growing pickleball courts.",
    topSports: ["tennis", "pickleball", "golf", "badminton"],
    highlights: ["San Jose Tennis Club", "Almaden Golf & CC", "Silicon Valley Pickleball"],
  },
  {
    name: "Jacksonville", state: "Florida", stateCode: "FL",
    slug: "jacksonville", stateSlug: "florida",
    lat: 30.3322, lng: -81.6557,
    description: "Florida's largest city with beachside courts and excellent year-round outdoor play.",
    topSports: ["tennis", "pickleball", "golf"],
    highlights: ["Boone Park Tennis", "Jax Beach Pickleball", "Queens Harbour Yacht & CC"],
  },
  {
    name: "Columbus", state: "Ohio", stateCode: "OH",
    slug: "columbus", stateSlug: "ohio",
    lat: 39.9612, lng: -82.9988,
    description: "Big Ten college city with active squash academy, public tennis, and growing pickleball leagues.",
    topSports: ["tennis", "squash", "pickleball", "table-tennis"],
    highlights: ["Wolfe Park Tennis", "Columbus Squash Academy", "Pickleball Columbus"],
  },
  {
    name: "Charlotte", state: "North Carolina", stateCode: "NC",
    slug: "charlotte", stateSlug: "north-carolina",
    lat: 35.2271, lng: -80.8431,
    description: "Rapidly growing city with excellent tennis infrastructure and expanding golf and pickleball scene.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Charlotte Tennis Center", "Quail Hollow Club", "Charlotte Pickleball Club"],
  },
  {
    name: "Indianapolis", state: "Indiana", stateCode: "IN",
    slug: "indianapolis", stateSlug: "indiana",
    lat: 39.7684, lng: -86.1581,
    description: "Active badminton and table tennis communities alongside great public park tennis.",
    topSports: ["tennis", "badminton", "table-tennis", "pickleball"],
    highlights: ["Garfield Park Tennis", "Indy Badminton Hub", "Eagle Creek Golf"],
  },
  {
    name: "San Francisco", state: "California", stateCode: "CA",
    slug: "san-francisco", stateSlug: "california",
    lat: 37.7749, lng: -122.4194,
    description: "Golden Gate Park's 21 courts, Mission Cliffs climbing gym, and a very active outdoor sports community.",
    topSports: ["tennis", "climbing", "pickleball", "squash"],
    highlights: ["Golden Gate Park Tennis", "Mission Cliffs Climbing", "SF Squash"],
  },
  {
    name: "Seattle", state: "Washington", stateCode: "WA",
    slug: "seattle", stateSlug: "washington",
    lat: 47.6062, lng: -122.3321,
    description: "Pacific Northwest's sports capital with active climbing gyms, pickleball hubs, and scenic park courts.",
    topSports: ["climbing", "pickleball", "tennis", "badminton"],
    highlights: ["Seattle Bouldering Project", "Rainier Pickleball Hub", "Volunteer Park Tennis"],
  },
  {
    name: "Nashville", state: "Tennessee", stateCode: "TN",
    slug: "nashville", stateSlug: "tennessee",
    lat: 36.1627, lng: -86.7816,
    description: "Fast-growing city with the Centennial Sportsplex as a top public tennis/pickleball complex.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Centennial Sportsplex", "Percy Warner Golf", "The Club at Cannery Row"],
  },
  {
    name: "Boston", state: "Massachusetts", stateCode: "MA",
    slug: "boston", stateSlug: "massachusetts",
    lat: 42.3601, lng: -71.0589,
    description: "Historic hub with world-class squash, Charles River esplanade tennis, and competitive leagues.",
    topSports: ["squash", "tennis", "pickleball", "table-tennis"],
    highlights: ["Harvard Squash Courts", "Charlesbank Tennis", "Boston Sports Clubs"],
  },
  {
    name: "Portland", state: "Oregon", stateCode: "OR",
    slug: "portland", stateSlug: "oregon",
    lat: 45.5051, lng: -122.6750,
    description: "Outdoor-loving city with great climbing, pickleball, and forested park tennis courts.",
    topSports: ["climbing", "pickleball", "tennis"],
    highlights: ["Portland Rock Gym", "SE Pickleball Courts", "Washington Park Tennis"],
  },
  {
    name: "Las Vegas", state: "Nevada", stateCode: "NV",
    slug: "las-vegas", stateSlug: "nevada",
    lat: 36.1699, lng: -115.1398,
    description: "Desert sports mecca with top golf courses, the Darling Tennis Center, and growing padel scene.",
    topSports: ["tennis", "golf", "pickleball", "padel"],
    highlights: ["Darling Tennis Center", "TPC Las Vegas", "Whitney Ranch Pickleball"],
  },
  {
    name: "Atlanta", state: "Georgia", stateCode: "GA",
    slug: "atlanta", stateSlug: "georgia",
    lat: 33.7490, lng: -84.3880,
    description: "Southern sports powerhouse — Piedmont Park tennis, Atlanta Bouldering Project, and growing padel scene.",
    topSports: ["tennis", "climbing", "pickleball", "padel"],
    highlights: ["Piedmont Park Tennis", "Atlanta Bouldering Project", "Colony Square Pickleball"],
  },
  {
    name: "Miami", state: "Florida", stateCode: "FL",
    slug: "miami", stateSlug: "florida",
    lat: 25.7617, lng: -80.1918,
    description: "International city with top padel clubs, world-famous tennis academies, and beachside fitness culture.",
    topSports: ["tennis", "padel", "pickleball", "golf"],
    highlights: ["Flamingo Park Tennis", "Miami Padel Club", "Key Biscayne Tennis"],
  },
  {
    name: "Minneapolis", state: "Minnesota", stateCode: "MN",
    slug: "minneapolis", stateSlug: "minnesota",
    lat: 44.9778, lng: -93.2650,
    description: "Land of 10,000 lakes has excellent indoor facilities for year-round sports play.",
    topSports: ["tennis", "golf", "pickleball", "table-tennis"],
    highlights: ["Theodore Wirth Courts", "Rush Creek Golf Club", "Braemar Golf Course"],
  },
  {
    name: "Tampa", state: "Florida", stateCode: "FL",
    slug: "tampa", stateSlug: "florida",
    lat: 27.9506, lng: -82.4572,
    description: "Bay Area sports scene with Hillsborough Tennis Complex and rapidly growing pickleball.",
    topSports: ["tennis", "pickleball", "golf"],
    highlights: ["Hillsborough Tennis Complex", "Tampa Bay Pickleball", "Innisbrook Golf Resort"],
  },
  {
    name: "New Orleans", state: "Louisiana", stateCode: "LA",
    slug: "new-orleans", stateSlug: "louisiana",
    lat: 29.9511, lng: -90.0715,
    description: "Garden District parks, Audubon Park tennis, and unique sports culture.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Audubon Park Tennis", "City Park Tennis", "Lakewood Golf Club"],
  },
  {
    name: "Raleigh", state: "North Carolina", stateCode: "NC",
    slug: "raleigh", stateSlug: "north-carolina",
    lat: 35.7796, lng: -78.6382,
    description: "Research Triangle's sports hub with Millbrook Exchange tennis and active pickleball leagues.",
    topSports: ["tennis", "pickleball", "golf"],
    highlights: ["Millbrook Exchange Tennis", "Raleigh Pickleball Academy", "Lonnie Poole Golf Course"],
  },
  {
    name: "St. Louis", state: "Missouri", stateCode: "MO",
    slug: "st-louis", stateSlug: "missouri",
    lat: 38.6270, lng: -90.1994,
    description: "Forest Park hosts 16 public tennis courts and the city has a strong badminton scene.",
    topSports: ["tennis", "badminton", "golf", "pickleball"],
    highlights: ["Forest Park Tennis", "Algonquin Golf Club", "St. Louis Badminton Club"],
  },
  {
    name: "Cleveland", state: "Ohio", stateCode: "OH",
    slug: "cleveland", stateSlug: "ohio",
    lat: 41.4993, lng: -81.6944,
    description: "Lake Erie city with Edgewater Park tennis and historic squash clubs.",
    topSports: ["tennis", "squash", "golf", "pickleball"],
    highlights: ["Edgewater Park Tennis", "Cleveland Skating Club Squash", "Sleepy Hollow Golf"],
  },
  {
    name: "Pittsburgh", state: "Pennsylvania", stateCode: "PA",
    slug: "pittsburgh", stateSlug: "pennsylvania",
    lat: 40.4406, lng: -79.9959,
    description: "Schenley Park free courts and excellent indoor squash and pickleball facilities.",
    topSports: ["tennis", "golf", "squash", "pickleball"],
    highlights: ["Schenley Park Tennis", "Pittsburgh Golf Club", "Upper St. Clair Racquet Club"],
  },
  {
    name: "Orlando", state: "Florida", stateCode: "FL",
    slug: "orlando", stateSlug: "florida",
    lat: 28.5383, lng: -81.3792,
    description: "Sunshine State fun with major tennis complexes and thriving table tennis community.",
    topSports: ["tennis", "table-tennis", "pickleball", "golf"],
    highlights: ["USTA National Campus", "Orlando Table Tennis", "Bay Hill Club"],
  },
  {
    name: "Cincinnati", state: "Ohio", stateCode: "OH",
    slug: "cincinnati", stateSlug: "ohio",
    lat: 39.1031, lng: -84.5120,
    description: "Ault Park tennis and Ohio's first padel club make Cincinnati a rising sports destination.",
    topSports: ["tennis", "padel", "golf", "squash"],
    highlights: ["Ault Park Tennis", "Cincinnati Padel Club", "Hyde Park Country Club"],
  },
  {
    name: "Kansas City", state: "Missouri", stateCode: "MO",
    slug: "kansas-city", stateSlug: "missouri",
    lat: 39.0997, lng: -94.5786,
    description: "Swope Park tennis courts and a growing climbing center serve the KC metro sports community.",
    topSports: ["tennis", "climbing", "golf", "pickleball"],
    highlights: ["Swope Park Tennis", "KC Climbing Center", "Hallbrook Country Club"],
  },
  {
    name: "Detroit", state: "Michigan", stateCode: "MI",
    slug: "detroit", stateSlug: "michigan",
    lat: 42.3314, lng: -83.0458,
    description: "Palmer Park tennis courts and competitive table tennis leagues drive Detroit's sports scene.",
    topSports: ["tennis", "table-tennis", "golf", "badminton"],
    highlights: ["Palmer Park Tennis", "Detroit Table Tennis League", "Franklin Hills CC"],
  },
  {
    name: "Sacramento", state: "California", stateCode: "CA",
    slug: "sacramento", stateSlug: "california",
    lat: 38.5816, lng: -121.4944,
    description: "McKinley Park courts and NorCal's largest pickleball complex make Sac a great sports city.",
    topSports: ["tennis", "pickleball", "golf"],
    highlights: ["McKinley Park Tennis", "Sacramento Pickleball Complex", "Arden Hills Club"],
  },
  {
    name: "Honolulu", state: "Hawaii", stateCode: "HI",
    slug: "honolulu", stateSlug: "hawaii",
    lat: 21.3069, lng: -157.8583,
    description: "Diamond Head views from Kapiolani courts and tropical golf courses make Honolulu unique.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Kapiolani Tennis Courts", "Ko Olina Golf Club", "Hawaii Pickleball Federation"],
  },
  {
    name: "Louisville", state: "Kentucky", stateCode: "KY",
    slug: "louisville", stateSlug: "kentucky",
    lat: 38.2527, lng: -85.7585,
    description: "Cherokee Park's Olmsted-designed courts and a competitive squash community.",
    topSports: ["tennis", "squash", "golf", "pickleball"],
    highlights: ["Cherokee Park Tennis", "Louisville Squash Club", "Valhalla Golf Club"],
  },
  {
    name: "El Paso", state: "Texas", stateCode: "TX",
    slug: "el-paso", stateSlug: "texas",
    lat: 31.7619, lng: -106.4850,
    description: "Border city with mountain backdrop tennis courts and affordable public golf.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Memorial Park Tennis", "Ascarate Golf Course", "EP Pickleball League"],
  },
  {
    name: "Memphis", state: "Tennessee", stateCode: "TN",
    slug: "memphis", stateSlug: "tennessee",
    lat: 35.1495, lng: -90.0490,
    description: "Leftwich Tennis Center's 24 public courts and an active badminton club.",
    topSports: ["tennis", "golf", "badminton", "pickleball"],
    highlights: ["Leftwich Tennis Center", "Audubon Golf Club", "East Memphis Pickleball"],
  },
  {
    name: "Oklahoma City", state: "Oklahoma", stateCode: "OK",
    slug: "oklahoma-city", stateSlug: "oklahoma",
    lat: 35.4676, lng: -97.5164,
    description: "Mitch Park's premier tennis facility and Kickingbird Golf serve the OKC metro.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Mitch Park Tennis Center", "Kickingbird Golf Course", "OKC Pickleball"],
  },
  {
    name: "Albuquerque", state: "New Mexico", stateCode: "NM",
    slug: "albuquerque", stateSlug: "new-mexico",
    lat: 35.0853, lng: -106.6503,
    description: "High desert city with top tennis complex, Sandia Peak skiing, and beautiful outdoor sports.",
    topSports: ["tennis", "ski", "golf", "pickleball"],
    highlights: ["ABQ Tennis Complex", "Sandia Peak Ski Area", "Isleta Eagle Golf Course"],
  },
  {
    name: "Tucson", state: "Arizona", stateCode: "AZ",
    slug: "tucson", stateSlug: "arizona",
    lat: 32.2217, lng: -110.9265,
    description: "College town with Himmel Park courts and active table tennis community.",
    topSports: ["tennis", "golf", "table-tennis", "pickleball"],
    highlights: ["Himmel Park Tennis", "Tucson Table Tennis", "Ventana Canyon Golf"],
  },
  {
    name: "Fresno", state: "California", stateCode: "CA",
    slug: "fresno", stateSlug: "california",
    lat: 36.7378, lng: -119.7871,
    description: "Central Valley city with Woodward Park tennis and Fig Garden Golf Club.",
    topSports: ["tennis", "golf", "pickleball"],
    highlights: ["Woodward Park Tennis", "Fig Garden Golf Club", "Fresno Racquet Club"],
  },
  {
    name: "Riverside", state: "California", stateCode: "CA",
    slug: "riverside", stateSlug: "california",
    lat: 33.9533, lng: -117.3961,
    description: "Fairmount Park courts and a growing pickleball league in the Inland Empire.",
    topSports: ["tennis", "pickleball", "golf"],
    highlights: ["Fairmount Park Tennis", "Riverside Pickleball League", "Indian Hills Golf Club"],
  },
  {
    name: "Milwaukee", state: "Wisconsin", stateCode: "WI",
    slug: "milwaukee", stateSlug: "wisconsin",
    lat: 43.0389, lng: -87.9065,
    description: "Wilson Park courts and eastside badminton club make Milwaukee a solid sports city.",
    topSports: ["tennis", "badminton", "golf", "pickleball"],
    highlights: ["Wilson Park Tennis", "Brown Deer Golf Course", "Milwaukee Badminton Club"],
  },
  {
    name: "Baltimore", state: "Maryland", stateCode: "MD",
    slug: "baltimore", stateSlug: "maryland",
    lat: 39.2904, lng: -76.6122,
    description: "Druid Hill Park free courts and a strong urban squash program.",
    topSports: ["tennis", "squash", "golf", "pickleball"],
    highlights: ["Druid Hill Park Tennis", "Baltimore Squash & Fitness", "Turf Valley Resort Golf"],
  },
  {
    name: "Virginia Beach", state: "Virginia", stateCode: "VA",
    slug: "virginia-beach", stateSlug: "virginia",
    lat: 36.8529, lng: -75.9780,
    description: "Oceanfront city with top-tier tennis clubs, beach volleyball, and growing pickleball scene.",
    topSports: ["tennis", "pickleball", "golf"],
    highlights: ["Mt. Trashmore Tennis Courts", "Lake Wright Golf Course", "VB Pickleball Complex"],
  },
  {
    name: "Colorado Springs", state: "Colorado", stateCode: "CO",
    slug: "colorado-springs", stateSlug: "colorado",
    lat: 38.8339, lng: -104.8214,
    description: "Mountain city at 6,000 feet with outstanding ski access, climbing, and year-round racquet sports.",
    topSports: ["ski", "climbing", "tennis", "pickleball"],
    highlights: ["Pikes Peak Area Tennis", "CATS Climbing Gym", "Kissing Camels Golf Club"],
  },
];

// Helper: get city by state+city slug
export function getCityBySlug(stateSlug, citySlug) {
  return CITIES.find(c => c.stateSlug === stateSlug && c.slug === citySlug) || null;
}

// Sport display names
export const SPORT_DISPLAY = {
  tennis: "Tennis", pickleball: "Pickleball", golf: "Golf",
  "table-tennis": "Table Tennis", ski: "Skiing", padel: "Padel",
  squash: "Squash", badminton: "Badminton", climbing: "Climbing",
};
